import { __decorate, __metadata } from "tslib";
import { Default, EditorDefinition, Expose, MinLength, Model, ValidateNested, ModelId, Structure } from '@core/shared/model';
import { uuid } from '@core/shared/utils';
let ExamQuestionAnswer = /*#__PURE__*/(() => {
  let ExamQuestionAnswer = class ExamQuestionAnswer extends Model {};
  __decorate([MinLength(3), Expose(), Default(''), __metadata("design:type", String)], ExamQuestionAnswer.prototype, "text", void 0);
  __decorate([Expose(), Default(false), __metadata("design:type", Boolean)], ExamQuestionAnswer.prototype, "isCorrect", void 0);
  ExamQuestionAnswer = __decorate([EditorDefinition('admin', ['text', 'isCorrect']), ModelId("ExamQuestionAnswer") // auto-generated by generate-model-ids
  ], ExamQuestionAnswer);
  return ExamQuestionAnswer;
})();
export { ExamQuestionAnswer };
let ExamQuestionItem = /*#__PURE__*/(() => {
  let ExamQuestionItem = class ExamQuestionItem extends Model {
    toString() {
      return "Exam Question " + this.question;
    }
  };
  __decorate([Expose(), Default(() => uuid()), __metadata("design:type", String)], ExamQuestionItem.prototype, "id", void 0);
  __decorate([MinLength(3), Expose(), Default(''), __metadata("design:type", String)], ExamQuestionItem.prototype, "question", void 0);
  __decorate([Expose(), Structure(Array, () => ExamQuestionAnswer), ValidateNested(), Default([{}]), __metadata("design:type", Array)], ExamQuestionItem.prototype, "answers", void 0);
  ExamQuestionItem = __decorate([EditorDefinition('admin', {
    question: true,
    answers: {
      loadDefinition: 'admin'
    }
  }), ModelId("ExamQuestionItem") // auto-generated by generate-model-ids
  ], ExamQuestionItem);
  return ExamQuestionItem;
})();
export { ExamQuestionItem };